import { useState } from 'react';
import CardAccordion from '../CardAccordion';
import { constantFormValues } from '../../root';
import { NumericFormat } from 'react-number-format';
import { withValueCap } from 'pages/globals/global';
import InputLabel from 'components/InputLabel/index';
import { Col, Form, Row, Input, Select } from 'antd';
import SolutionCatalogIcon from 'assets/icons/solutions-catalog';
import HistoryModalContainer from 'components/modal/HistoryModalContainer';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableFooter } from '@mui/material';

const LeaseHistoryDetailModal = ({ showModal, setShowModal }) => {
	const [totalAmount, setTotalAmount] = useState(0);
	const [screenSize, setScreenSize] = useState('md');

	const handleClose = () => {
		setShowModal(false);
	};

	return (
		<HistoryModalContainer
			icon={<SolutionCatalogIcon color="#fff" width="20px" height="20px" />}
			showModal={showModal}
			screenSize={screenSize}
			handleClose={handleClose}
			title="Lease History Detail"
			setScreenSize={setScreenSize}
		>
			<Row gutter={[16, 0]}>
				<Col xs={24} md={12}>
					<CardAccordion
						sx={{ mb: 2 }}
						title="Lease Payment Schedule"
						typographySX={{ fontSize: '16px !important' }}
						customHeaderSX={{ backgroundColor: '#e1f0fb !important', p: '10px', mb: 3 }}
					>
						<Form.List name={'grossRentList'}>
							{(fields) => (
								<>
									<TableContainer
										className="gross-rent-table"
										sx={{
											'& table, & th, & td': {
												border: '1px solid #e0e0e0',
												borderCollapse: 'collapse',
											},
											'& th, & td': {
												p: '5px',
											},
											'& td .ant-form-item': {
												marginBottom: '0px',
											},

											'& th:nth-of-type(1), & td:nth-of-type(1)': { width: '20%' },
											'& th:nth-of-type(2), & td:nth-of-type(2)': { width: '20%' },
											'& table': { width: '100%' },
										}}
									>
										<Table aria-label="Gross Rent table">
											<TableHead>
												<TableRow>
													<TableCell sx={{ textAlign: 'center' }}>From Month</TableCell>
													<TableCell sx={{ textAlign: 'center' }}>To Month</TableCell>
													<TableCell sx={{ textAlign: 'center' }}>Amount</TableCell>
													{/* <TableCell sx={{ textAlign: 'center' }}>Notes</TableCell> */}
												</TableRow>
											</TableHead>
											<TableBody>
												{fields.length > 0 ? (
													fields.map((field, index) => (
														<TableRow key={field.key}>
															<TableCell>
																<Form.Item name={[field.name, 'from']}>
																	<Input
																		disabled={true}
																		style={{
																			padding: '8px',
																			width: '100%',
																			backgroundColor: '#f5f5f5',
																			textAlign: 'center',
																		}}
																	/>
																</Form.Item>
															</TableCell>

															<TableCell>
																<Form.Item name={[field.name, 'to']}>
																	<Input
																		type="number"
																		disabled={true}
																		placeholder="Enter To value"
																		style={{
																			width: '100%',
																			padding: '8px',

																			textAlign: 'center',
																		}}
																	/>
																</Form.Item>
															</TableCell>
															<TableCell>
																<Form.Item name={[field.name, 'amount']}>
																	<NumericFormat
																		size="small"
																		decimalScale={2}
																		placeholder="0.00"
																		fixedDecimalScale
																		thousandSeparator=","
																		isAllowed={withValueCap}
																		style={{
																			padding: '18px',
																			textAlign: 'right',
																			height: '32px',
																			borderRadius: '4px',
																			fontSize: '13px',
																		}}
																		customInput={Input}
																		disabled={true}
																	/>
																</Form.Item>
															</TableCell>
														</TableRow>
													))
												) : (
													<TableRow>
														<TableCell colSpan={5} style={{ textAlign: 'center' }}>
															No data. Click plus icon in action column to add new entries.
														</TableCell>
													</TableRow>
												)}
											</TableBody>
										</Table>
									</TableContainer>
								</>
							)}
						</Form.List>
					</CardAccordion>

					<Row gutter={[16, 0]}>
						<Col xs={24} md={6}>
							<InputLabel label="Payment Frequency" head={true} />
						</Col>

						<Col xs={24} md={6}>
							<Form.Item name={constantFormValues?.paymentFrequency?.key}>
								<Select
									showSearch
									disabled={true}
									filterOption={true}
									optionFilterProp="children"
									placeholder="Select from the list"
									style={{ width: '100%', height: '32px', borderRadius: '4px' }}
								>
									{constantFormValues?.paymentFrequency?.options?.map(({ key, value, label }) => (
										<Select.Option key={key} value={value}>
											{label}
										</Select.Option>
									))}
								</Select>
							</Form.Item>
						</Col>

						<Col xs={24} md={6}>
							<InputLabel label={constantFormValues?.paymentModality?.label} head={true} />
						</Col>
						<Col xs={24} md={6}>
							<Form.Item name={constantFormValues?.paymentModality?.key}>
								<Select
									showSearch
									disabled={true}
									filterOption={true}
									optionFilterProp="children"
									placeholder="Select from the list"
									style={{ width: '100%', height: '32px', borderRadius: '4px' }}
								>
									{constantFormValues?.paymentModality?.options?.map(({ key, value, label }) => (
										<Select.Option key={key} value={value}>
											{label}
										</Select.Option>
									))}
								</Select>
							</Form.Item>
						</Col>
					</Row>
				</Col>

				<Col xs={24} md={12}>
					<CardAccordion
						sx={{ mb: 2 }}
						darkTitle={false}
						title="Advance Payment & Adjustment"
						typographySX={{ fontSize: '16px !important' }}
						customHeaderSX={{ backgroundColor: '#e1f0fb !important', p: '10px', mb: 3 }}
					>
						{/* <AdvanceAmount formListName="advanceAmountList" screen={screen} dataFullyLoaded={dataFullyLoaded} /> */}

						<Form.List name={'advanceAmountList'}>
							{(fields) => {
								return (
									<>
										<TableContainer
											className="gross-rent-table"
											sx={{
												'& table, & th, & td': {
													border: '1px solid #e0e0e0',
													borderCollapse: 'collapse',
												},
												'& th, & td': {
													p: '5px',
												},
												'& td .ant-form-item': {
													marginBottom: '0px',
												},

												'& th:nth-of-type(1), & td:nth-of-type(1)': { width: '20%' } /* From/From Month */,
												'& th:nth-of-type(2), & td:nth-of-type(2)': { width: '20%' } /* To/To Month */,
												'& table': { width: '100%' } /* Ensure table takes full container width */,
											}}
										>
											<Table aria-label="Gross Rent table">
												<TableHead>
													<TableRow>
														<TableCell sx={{ textAlign: 'center' }}>From Month</TableCell>
														<TableCell sx={{ textAlign: 'center' }}>To Month</TableCell>
														<TableCell sx={{ textAlign: 'center' }}>Monthly Adjustment</TableCell>
													</TableRow>
												</TableHead>
												<TableBody>
													{fields.length > 0 ? (
														fields.map((field, index) => (
															<TableRow key={field.key}>
																<TableCell>
																	<Form.Item name={[field.name, 'from']}>
																		<Input
																			disabled={true} // Always disabled to prevent manual editing
																			style={{
																				padding: '8px',
																				width: '100%',
																				backgroundColor: '#f5f5f5', // Grey background to indicate disabled
																				textAlign: 'center',
																			}}
																		/>
																	</Form.Item>
																</TableCell>

																<TableCell>
																	<Form.Item name={[field.name, 'to']}>
																		<Input
																			type="number"
																			disabled={true}
																			placeholder="Enter To value"
																			style={{
																				padding: '8px',
																				width: '100%',

																				textAlign: 'center',
																			}}
																		/>
																	</Form.Item>
																</TableCell>
																<TableCell>
																	<Form.Item name={[field.name, 'amount']}>
																		<NumericFormat
																			size="small"
																			decimalScale={2}
																			placeholder="0.00"
																			fixedDecimalScale
																			thousandSeparator=","
																			isAllowed={withValueCap}
																			style={{
																				padding: '18px',
																				textAlign: 'right',
																				height: '32px',
																				borderRadius: '4px',
																				fontSize: '13px',
																			}}
																			customInput={Input}
																			disabled={true}
																		/>
																	</Form.Item>
																</TableCell>
															</TableRow>
														))
													) : (
														<TableRow>
															<TableCell colSpan={5} style={{ textAlign: 'center' }}>
																No data. Click the plus icon to add new entries.
															</TableCell>
														</TableRow>
													)}
												</TableBody>

												<TableFooter>
													<TableRow sx={{ height: 24 }}>
														<TableCell colSpan={2} align="right" style={{ fontWeight: 'bold' }}>
															<InputLabel
																label={'Advance Payment'}
																head={true}
																sx={{
																	justifyContent: 'end',
																	marginBottom: '0px',
																}}
															/>
														</TableCell>
														<TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>
															<NumericFormat
																value={totalAmount || 0}
																displayType="input"
																decimalScale={2}
																fixedDecimalScale
																thousandSeparator=","
																size="small"
																style={{
																	padding: '18px',
																	textAlign: 'right',
																	height: '32px',
																	borderRadius: '4px',
																	fontSize: '13px',
																	fontWeight: 'bold',
																	backgroundColor: undefined,
																	borderColor: undefined,
																}}
																customInput={Input}
																disabled={true}
																readOnly={true}
															/>
														</TableCell>
													</TableRow>
												</TableFooter>
											</Table>
										</TableContainer>
									</>
								);
							}}
						</Form.List>
					</CardAccordion>
				</Col>

				<Col xs={24}>
					<CardAccordion
						darkTitle={false}
						title="Other Payments & Incentive"
						typographySX={{ fontSize: '16px !important' }}
						customHeaderSX={{ backgroundColor: '#e1f0fb !important', p: '10px' }}
					>
						<Row gutter={[16, 0]}>
							<Col xs={24} md={4}>
								<InputLabel label={constantFormValues?.upfrontLeasePayment?.label} head={true} />
							</Col>

							<Col xs={24} md={8}>
								<Form.Item name={constantFormValues?.upfrontLeasePayment?.key} rules={constantFormValues?.upfrontLeasePayment?.rules}>
									<NumericFormat
										size="large"
										disabled={true}
										decimalScale={2}
										placeholder="0.00"
										fixedDecimalScale
										customInput={Input}
										thousandSeparator=","
										isAllowed={withValueCap}
										style={{ textAlign: 'right', height: '32px', borderRadius: '4px', fontSize: '13px' }}
									/>
								</Form.Item>
							</Col>

							<Col xs={24} md={4}>
								<InputLabel label={constantFormValues?.initialDirectCost?.label} head={true} />
							</Col>

							<Col xs={24} md={8}>
								<Form.Item name={constantFormValues?.initialDirectCost?.key} rules={constantFormValues?.initialDirectCost?.rules}>
									<NumericFormat
										size="large"
										disabled={true}
										decimalScale={2}
										placeholder="0.00"
										fixedDecimalScale
										customInput={Input}
										thousandSeparator=","
										isAllowed={withValueCap}
										style={{ textAlign: 'right', height: '32px', borderRadius: '4px', fontSize: '13px' }}
									/>
								</Form.Item>
							</Col>

							<Col xs={24} md={4}>
								<InputLabel label={constantFormValues?.securityDeposit?.label} head={true} />
							</Col>

							<Col xs={24} md={8}>
								<Form.Item name={constantFormValues?.securityDeposit?.key} rules={constantFormValues?.securityDeposit?.rules}>
									<NumericFormat
										size="large"
										disabled={true}
										decimalScale={2}
										placeholder="0.00"
										fixedDecimalScale
										customInput={Input}
										thousandSeparator=","
										isAllowed={withValueCap}
										style={{ textAlign: 'right', height: '32px', borderRadius: '4px', fontSize: '13px' }}
									/>
								</Form.Item>
							</Col>

							<Col xs={24} md={4}>
								<InputLabel label={constantFormValues?.cashIncentiveAmount?.label} head={true} />
							</Col>

							<Col xs={24} md={8}>
								<Form.Item name={constantFormValues?.cashIncentiveAmount?.key} rules={constantFormValues?.securityDeposit?.rules}>
									<NumericFormat
										size="large"
										disabled={true}
										decimalScale={2}
										placeholder="0.00"
										fixedDecimalScale
										customInput={Input}
										thousandSeparator=","
										isAllowed={withValueCap}
										style={{ textAlign: 'right', height: '32px', borderRadius: '4px', fontSize: '13px' }}
									/>
								</Form.Item>
							</Col>
						</Row>
					</CardAccordion>
				</Col>
			</Row>
		</HistoryModalContainer>
	);
};

export default LeaseHistoryDetailModal;
